import VehicleIdentificationcodeModal from './vehicle-identificationcode-modal.vue'
export default VehicleIdentificationcodeModal
